import type { SVGProps } from 'react'

interface SvgEditProps extends SVGProps<SVGSVGElement> {
  disabled?: boolean
}

const SvgDelete = ({ disabled = false, ...props }: SvgEditProps) => (
  <svg
    width="15"
    height="16"
    viewBox="0 0 9 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    style={{
      cursor: disabled ? 'not-allowed' : 'pointer',
      opacity: disabled ? 0.5 : 1,
      ...props.style,
    }}
  >
    <path
      d="M1.68465 11.4001C1.38545 11.4001 1.12985 11.2872 0.917849 11.0613C0.705949 10.8352 0.599999 10.5628 0.599999 10.2438L0.6 2.12532L-1.33339e-07 2.12532L-4.94605e-08 1.16586L2.7 1.16586L2.7 0.600098L6.3 0.600098L6.3 1.16586L9 1.16586L9 2.12532L8.4 2.12532L8.4 10.2438C8.4 10.5669 8.295 10.8404 8.085 11.0643C7.875 11.2882 7.61845 11.4001 7.31535 11.4001L1.68465 11.4001ZM7.5 2.12532L1.5 2.12532L1.5 10.2438C1.5 10.3013 1.5173 10.3484 1.5519 10.3853C1.5865 10.4222 1.63075 10.4406 1.68465 10.4406L7.31535 10.4406C7.36155 10.4406 7.40385 10.4201 7.44225 10.3791C7.48075 10.3381 7.5 10.293 7.5 10.2438L7.5 2.12532ZM2.9424 9.16136L3.84225 9.16136L3.84225 3.4046L2.9424 3.4046L2.9424 9.16136ZM5.15775 9.16136L6.0576 9.16136L6.0576 3.4046L5.15775 3.4046L5.15775 9.16136Z"
      fill="#5E5E5E"
    />
  </svg>
)

export default SvgDelete
